import React from "react";
import { Mail, MessageCircle, Smartphone } from "lucide-react";
import "../styles/Contact.css";

function Contact() {
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      <p>If you’d like to reach us, choose any of the options below:</p>

      <div className="contact-options">
        <a
          href="mailto:fpl365official@gmail.com"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card"
        >
          <Mail size={28} />
          <span>Email Us</span>
        </a>

        <a
          href="sms:+254745775795"
          className="contact-card"
        >
          <Smartphone size={28} />
          <span>Send SMS</span>
        </a>

        <a
          href="https://wa.me/254745775795"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-card"
        >
          <MessageCircle size={28} />
          <span>WhatsApp</span>
        </a>
      </div>
    </div>
  );
}

export default Contact;
